import { render } from "./ProfilePreferences.view.vue?vue&type=template&id=2445b00c"
import script from "./ProfilePreferences.view.vue?vue&type=script&lang=js"
export * from "./ProfilePreferences.view.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__